import { AutogenLayoutRenditionBillingDetail } from "./autogen/AutogenLayoutRenditionBillingDetail";
import { DataSourceMode, DataSourceModeChangeEvent, ClickEvent, DropdownItem, DataDisplayEvent, DragEvent, DataSourceExecutionEvent,  DropdownSelectionEvent } from "@mcleod/components";

const typesMap = new Map<string, string>();

export class RenditionBillingDetail extends AutogenLayoutRenditionBillingDetail {

  override onLoad() {
        //console.log(this);
        this.sourceRenditionTypes.search();   //get all fields
  }

  /** This is an event handler for the afterModeChange event of sourceRenditionBilling. */
  sourceRenditionBillingAfterModeChange(event: DataSourceModeChangeEvent) {
        if (event.newMode === DataSourceMode.SEARCH)
            event.dataSource.searchRow.set("renb_done", "N");
    }

/** This is an event handler for the onClick event of textboxRenbBatchid. */
  textboxRenbBatchidOnClick(event: ClickEvent) {

  }

/** This is an event handler for the onDataDisplay event of textboxRenbBatchid. */
  textboxRenbBatchidOnDataDisplay(event: DataDisplayEvent) {

  }

/** This is an event handler for the onDragOver event of textboxRenbBatchid. */
  textboxRenbBatchidOnDragOver(event: DragEvent) {

  }

/** This is an event handler for the onDragStart event of textboxRenbBatchid. */
  textboxRenbBatchidOnDragStart(event: DragEvent) {

  }

/** This is an event handler for the afterExecution event of sourceRenditionTypes. */
  sourceRenditionTypesAfterExecution(event: DataSourceExecutionEvent) {
    const rows: any[] = event.dataSource.data;
    const items: DropdownItem[] = [];
    typesMap.clear();
    for (const row of rows) {
        //console.log("Row: ", row );
        //items.push({ caption: row._data.typep_desc });
        items.push(new DropdownItem(row._data.typep_desc, row._data.typep_desc));
        typesMap.set( row._data.typep_desc, row._data.typep_id );
    }
    this.textboxRenbBilltype.items = items;
  }

/** This is an event handler for the onDropdownSelection event of textboxRenbBilltype. */
  textboxRenbBilltypeAfterDropdownSelection(event: DropdownSelectionEvent) {
    this.sourceRenditionBilling.searchRow.set("renb_billtype", typesMap.get(event.selection.displayValue));
  }

}
